import { PatientGroup } from '@dreryk/egabinet-patient-frontend-api';

import { createInterpolatedTranslationKey } from '@dreryk/react-common';
import { Modal, ModalCancelButton, ModalCloseButton, ModalConfirmButton, ModalWidth } from '@dreryk/react-components';

import { translationKeys } from '../../../translations';

import { PredefinedPatientGroupsUpdateForm } from './PredefinedPatientGroupsUpdateForm';
import { PredefinedPatientGroupsUpdateEffectsAction } from './PredefinedPatientGroupsUpdateModal.actions';
import { mapPatientGroupEffectsToFormBean } from './PredefinedPatientGroupsUpdateForm.utils';

type PredefinedPatientGroupsUpdateSettingsModalProps = {
   patientGroup: PatientGroup;
   onClose: VoidFunction;
};

export const PredefinedPatientGroupsUpdateSettingsModal = (
   props: PredefinedPatientGroupsUpdateSettingsModalProps
): JSX.Element => {
   return (
      <Modal
         title={createInterpolatedTranslationKey(translationKeys.updateSettingsGroup, {
            groupName: props.patientGroup.name,
         })}
         width={ModalWidth.NORMAL}
         testId={'updateSettingsPredefinedPatientGroups'}
      >
         <PredefinedPatientGroupsUpdateForm initializer={mapPatientGroupEffectsToFormBean(props.patientGroup.effects)}>
            {({ handleSubmit, formState }) => (
               <>
                  <PredefinedPatientGroupsUpdateEffectsAction
                     patientGroupId={props.patientGroup.id}
                     onSuccess={props.onClose}
                  >
                     {({ updatePatientGroupEffects }) => (
                        <ModalConfirmButton
                           label={translationKeys.save}
                           onClick={handleSubmit(updatePatientGroupEffects)}
                        />
                     )}
                  </PredefinedPatientGroupsUpdateEffectsAction>

                  <ModalCancelButton onClick={props.onClose} shouldConfirmExit={formState.isDirty} />
                  <ModalCloseButton onClick={props.onClose} shouldConfirmExit={formState.isDirty} />
               </>
            )}
         </PredefinedPatientGroupsUpdateForm>
      </Modal>
   );
};
